module.exports = __webpack_public_path__ + "static/img/newThree.fc2f4ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/earnImg/newThree.png
// module id = XfrC
// module chunks = 1